function adjustCollapseView() {
  var desktopView = $(window).width();
  if (desktopView >= "1024") {
    $(".navbar .dropdown-toggle[data-toggle]").attr("data-toggle", "");

    $(".navbar .dropdown-toggle").click(function (event) {
      event.preventDefault();
    });
    //WPML lang switcher
    $(".footer-lang-switcher .wpml-ls-item-toggle").click(function (event) {
      event.preventDefault();
      $(this).toggleClass("dropdown-show");
    });
  } else {
    $(".menu-item-has-children .dropdown-toggle").click(function (event) {
      event.preventDefault();
    });

    $(".navbar-toggler").click(function (event) {
      event.preventDefault();
    });

    $(".navbar .dropdown-toggle[data-toggle]").attr("data-toggle", "dropdown");

    $(
      ".menu-item-has-children:not(.wpml-ls-item), .menu-item-has-children:not(.wpml-ls-item) .dropdown-menu"
    ).addClass("show");

    //WPML lang switcher
    $(".footer-lang-switcher .wpml-ls-item-toggle").addClass("dropdown-show");

    $(
      ".menu-item-has-children.wpml-ls-item, .footer-lang-switcher .wpml-ls-item-toggle"
    ).click(function (event) {
      event.preventDefault();
      $(this).addClass("dropdown-show");
      $(this).find(".dropdown-menu").addClass("show");
    });

    $(".menu-item-has-children [data-toggle='dropdown']").attr(
      "aria-expended",
      "true"
    );
  }
}

export default adjustCollapseView;
